<div class="row g-0">
  @if (partsData$ | async; as partsData) {
    <div class="col-12 col-md-3">
      <div class="title-of-box-hold">
        <h5 class="strong">Refine Search</h5>
      </div>
      <div class="bg-white border p-4">
        @if (isInternal$ | async) {
          <div id="partList_div_in_stock" tabindex="-1" class="py-1">
            <input id="partList_checkbox_in_stock" tabindex="-1" type="checkbox" name="in-stock" [(ngModel)]="inStockOnly" value="option" (change)="onInStockChange($event)">
            <label tabindex="-1" for="partList_checkbox_in_stock" class="m-0">
              Show In-Stock Parts Only
            </label>
          </div>
        }
        <h5>Manufacturers</h5>
        @if (partsData.facets && partsData.facets.manufacturer.buckets) {
          <div id="partList_div_partDataFacetsManufacturers" tabindex="-1">
            @for (manufacturer of manufacturerBuckets$ | async; track manufacturer.term; let i = $index) {
              <div id="partList_div_partDataFacetsManufacturer_{{i}}" tabindex="-1" class="py-1">
                <input id="partList_checkbox_Manufacturer_{{i}}" tabindex="-1" type="checkbox" name="field" value="option"
                  [(ngModel)]="manufacturer.selected" (change)="onFacetChange(partsData.facets)">
                  <label tabindex="-1" for="partList_checkbox_Manufacturer_{{i}}" class="m-0">{{manufacturer.term!=''?
                    manufacturer.term:'Other'}} ({{manufacturer.count | number:'.0'}})
                  </label>
                </div>
              }
            </div>
          }
          <hr>
            <h5>Category</h5>
            @if (partsData.facets && partsData.facets.category.buckets) {
              <div id="partList_div_partDataFacetsCategories" tabindex="-1">
                @for (category of partsData.facets.category.buckets; track category.term; let i = $index) {
                  <div id="partList_div_partDataFacetsCategory_{{i}}" tabindex="-1" class="py-1">
                    <input id="partList_checkbox_Category_{{i}}" tabindex="-1" type="checkbox" name="field" value="option"
                      [(ngModel)]="category.selected" (change)="onFacetChange(partsData.facets)">
                      <label tabindex="-1" for="partList_checkbox_Category_{{i}}" class="m-0">{{category.term!=''?
                      category.term:'Other'}} ({{category.count | number:'.0'}})</label>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }

        <div class="col-12 col-md-9 ps-md-3 part-list-main-content">
          <div class="title-of-box-hold">
            <h5 class="strong">{{ totalParts$ | async | number:'.0' }} parts found for <span class="text-primary">"{{partSearchTerm}}"</span></h5>
          </div>

          <div>
            <div class="p-3 gx-1 flex-unset">
              <span>Filters:</span>
              @if (!selectedFacets.length) {
                <span id="partList_span_NoFiltersApplied" class="badge bg-medium">No filters applied</span>
              }
              @for (facet of selectedFacets; track facet) {
                @for (refinement of facet.terms; track refinement; let i = $index) {
                  <span id="partList_span_Refine_{{i}}" class="badge bg-medium">{{refinement != '' ? refinement : 'Other'}}</span>
                }
              }
            </div>
            @if (!inStockOnly) {
              <div>
                @if (partsData$ | async; as partsData) {
                  <div class="product-list gy-3" id="product-list-container">
                    <!--Product List Card Start-->
                    @for (part of parts; track part.partId; let i = $index) {
                      <div id="partList_div_PartsData" class="product-card border rounded-lg row g-0 bg-white" [ngClass]="{ 'disabled-card': !part.quantityAvailable }">
                        <div class="col-sm-12 col-md-4 col-lg-4">
                          <a id="partList_div_RushPartNumber" href="javascript:void(0)" (click)="selectPart(part)">
                            <h4 class="product-card-title m-0 px-3 py-2 d-flex justify-content-between" #productCardTitle>
                              <span class="strong">
                                {{ part.rushPartNumber || part.number }}
                              </span>
                              <div>
                                @if (part.isFavoritePart) {
                                  <a id="partList_a_RemoveFromFavorites" href="javascript:void(0)" title="Remove from Favorites"
                                    (click)="removeFavoritePart(part); $event.stopPropagation()">
                                    <i class="fas fa-star"></i>
                                  </a>
                                }
                                @if (!part.isFavoritePart) {
                                  <a id="partList_a_AddToFavorites" href="javascript:void(0)" title="Add to Favorites"
                                    (click)="addToFavoriteParts(part); $event.stopPropagation()">
                                    <i class="far fa-star"></i>
                                  </a>
                                }
                                &nbsp;
                                <a id="partList_a_CopyPartNumberToClipboard" href="javascript:void(0)" title="Copy Part Number to Clipboard"
                                  (click)="copyPartNumberToClipBoard(part); $event.stopPropagation()">
                                  <i class="far fa-clone"></i>
                                </a>
                              </div>
                            </h4>
                            <div class="product-image product-image-md" tabindex="-1">
                              <img [src]="getImage(part.image, imageBaseUrl, '100X100')" [default]="'assets/img/100X100_No_Image.png'" tabindex="-1" alt="No Image" >
                            </div>
                          </a>
                        </div>
                        <div class="col-sm-12 col-md-5 col-lg-5 border-start border-end">
                          <div class="border-bottom px-3 d-flex align-items-center text-truncate" [ngStyle]="{ 'height.px': productCardTitle.offsetHeight }">
                            <b>{{part.quantityAvailable | number:'.0'}} Available</b> - {{branch.code}} - {{part.branchName}}
                          </div>
                          <div>
                            <div class="p-3 row">
                              <div class="col-6">
                                <b>VMRS Description</b>
                                <div class="text-truncate" title="{{part.vmrsDescription}}">{{part.vmrsDescription}}</div>
                              </div>
                              <div class="col-6">
                                <b>VMRS Code</b>
                                <div>{{part.vmrsCode}}</div>
                              </div>
                            </div>
                            <div class="p-3 row">
                              @if (part.corePart) {
                                <div class="col-6">
                                  <b>Core No.</b>
                                  <div>{{part.corePart}}</div>
                                </div>
                              }
                              <div class="col-6">
                                <b>Item Summary</b>
                                <div>{{part.description}}</div>
                              </div>
                            </div>
                            @if (part.comments) {
                              <div class="p-3 row">
                                <div class="col-12">
                                  <h5 class="strong"></h5>
                                  <p>Your search of {{part.comments}}</p>
                                </div>
                              </div>
                            }
                            @if (part.corePart !== null && part.corePart !== '') {
                              <div class="p-4 col-12">
                                <select id="part_search_select_core_{{i}}" class="form-control core-options" [ngModel]="part.coreOption" (ngModelChange)="selectCoreReturn($event, part);">
                                  <option [value]="'NOCORER'">No Core Returned</option>
                                  <option [value]="'CORE1'">Core Returned</option>
                                </select>
                              </div>
                            }
                            @if (part.hazmat) {
                              <div class="p-3 row">
                                <div class="alert alert-danger col-11 ms-3 mb-0" id="hazmat-errors">
                                  <span><i class="fas fa-exclamation-triangle"></i> Hazmat products not eligible for freight delivery. In-store pickup and local delivery are still available for this product.</span>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                        <div class="col-sm-12 col-md-3 col-lg-3 d-flex align-items-center flex-wrap couponPrice">
                          <pricing id="partList_pricing_Part" [part]="part" [branch]="branch" (extend)="onExtendPart($event)" [displayType]="displayType"></pricing>
                          @if (displayType === 'back-counter-tool') {
                            <part-quantity  [value]="part.quantity" (onChangeQuantity)="changeQuantity($event, part)" [min]="1" [max]="10000"></part-quantity>
                            <button class="btn btn-primary" (click)="addToRequest(part);" [disabled]="!part.isRushPart || (part.isRushPart && !part.isExtendedToBranch)">Add To Request</button>
                          }
                        </div>
                        <!-- TODO: national inventory url/href need to correct. -->
                        @if (!(isQuote$ | async) && part.isRushPart) {
                          <div id="partList_div_IsQuote" class="col-12 border-top p-2 d-flex justify-content-center">
                            <a id="partList_div_NationalInventory" class="hyperlink" href="javascript:void(0)" (click)="openNationalInventory(part)">National Inventory</a>
                          </div>
                        }
                      </div>
                    }
                    <!--Product List Card End-->
                  </div>
                }
                <pagination [currentPage]="currentPage" idPrefix="partList" [totalCount]="totalParts$" [pageSize]="pageSize" (currentPageChange)="setPage($event); scrollToTop(); showLoader();"></pagination>
              </div>
            } @else {
              @if (allParts$ | async; as partsData) {
                <div class="product-list product-list-in-stock gy-3" (scroll)="onScroll($event)">
                  <!--Product List Card Start-->
                  @for (part of partsData.parts; track part.partId; let i = $index) {
                    <div id="partList_div_instock_PartsData" class="product-card border rounded-lg row g-0 bg-white" [ngClass]="{ 'disabled-card': !part.quantityAvailable }">
                      <div class="col-sm-12 col-md-4 col-lg-4">
                        <a id="partList_div_RushPartNumber" href="javascript:void(0)" (click)="selectPart(part)">
                          <h4 class="product-card-title m-0 px-3 py-2 d-flex justify-content-between" [ngClass]="{ 'highlighted': part.partNumber === highlightPart?.partNumber && part.rushPartNumber === highlightPart?.rushPartNumber }" #productCardTitle>
                            <span class="strong">
                              {{ part.rushPartNumber || part.number }}
                            </span>
                            <div>
                              @if (part.isFavoritePart) {
                                <a id="partList_a_RemoveFromFavorites" href="javascript:void(0)" title="Remove from Favorites"
                                  (click)="removeFavoritePart(part); $event.stopPropagation()">
                                  <i class="fas fa-star"></i>
                                </a>
                              }
                              @if (!part.isFavoritePart) {
                                <a id="partList_a_AddToFavorites" href="javascript:void(0)" title="Add to Favorites"
                                  (click)="addToFavoriteParts(part); $event.stopPropagation()">
                                  <i class="far fa-star"></i>
                                </a>
                              }
                              &nbsp;
                              <a id="partList_a_CopyPartNumberToClipboard" href="javascript:void(0)" title="Copy Part Number to Clipboard"
                                (click)="copyPartNumberToClipBoard(part); $event.stopPropagation()">
                                <i class="far fa-clone"></i>
                              </a>
                            </div>
                          </h4>
                          <div class="product-image product-image-md" tabindex="-1">
                            <img [src]="getImage(part.image, imageBaseUrl, '100X100')" [default]="'assets/img/100X100_No_Image.png'" tabindex="-1" alt="No Image" >
                          </div>
                        </a>
                      </div>
                      <div class="col-sm-12 col-md-5 col-lg-5 border-start border-end">
                        <div class="border-bottom px-3 d-flex align-items-center text-truncate" [ngStyle]="{ 'height.px': productCardTitle.offsetHeight }">
                          <b>{{part.quantityAvailable | number:'.0'}} Available</b> - {{branch.code}} - {{part.branchName}}
                        </div>
                        <div>
                          <div class="p-3 row">
                            <div class="col-6">
                              <b>VMRS Description</b>
                              <div class="text-truncate" title="{{part.vmrsDescription}}">{{part.vmrsDescription}}</div>
                            </div>
                            <div class="col-6">
                              <b>VMRS Code</b>
                              <div>{{part.vmrsCode}}</div>
                            </div>
                          </div>
                          <div class="p-3 row">
                            @if (part.corePart) {
                              <div class="col-6">
                                <b>Core No.</b>
                                <div>{{part.corePart}}</div>
                              </div>
                            }
                            <div class="col-6">
                              <b>Item Summary</b>
                              <div>{{part.description}}</div>
                            </div>
                          </div>
                          @if (part.comments) {
                            <div class="p-3 row">
                              <div class="col-12">
                                <p>Your search of {{part.comments}}</p>
                              </div>
                            </div>
                          }
                          @if (part.corePart !== null && part.corePart !== '') {
                            <div class="p-4 col-12">
                              <select id="part_search_select_core_{{i}}" class="form-control core-options" [ngModel]="part.coreOption" (ngModelChange)="selectCoreReturn($event, part);">
                                <option [value]="'NOCORER'">No Core Returned</option>
                                <option [value]="'CORE1'">Core Returned</option>
                              </select>
                            </div>
                          }
                          @if (part.hazmat) {
                            <div class="p-3 row">
                              <div class="alert alert-danger col-11 ms-3 mb-0" id="hazmat-errors">
                                <span><i class="fas fa-exclamation-triangle"></i> Hazmat products not eligible for freight delivery. In-store pickup and local delivery are still available for this product.</span>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-3 col-lg-3 d-flex align-items-center flex-wrap couponPrice">
                        <pricing id="partList_pricing_Part" [part]="part" [branch]="branch" (extend)="onExtendPart($event)" [displayType]="displayType"></pricing>
                        @if (displayType === 'back-counter-tool') {
                          <part-quantity  [value]="part.quantity" (onChangeQuantity)="changeQuantity($event, part)" [min]="1" [max]="10000"></part-quantity>
                          <button class="btn btn-primary" (click)="addToRequest(part);" [disabled]="!part.isRushPart || (part.isRushPart && !part.isExtendedToBranch)">Add To Request</button>
                        }
                      </div>
                      @if (!(isQuote$ | async) && part.isRushPart) {
                        <div id="partList_div_IsQuote" class="col-12 border-top p-2 d-flex justify-content-center">
                          <a id="partList_div_NationalInventory" class="hyperlink" href="javascript:void(0)" (click)="openNationalInventory(part)">National Inventory</a>
                        </div>
                      }
                    </div>
                  }
                  @if (partsData.parts.length > 0) {
                    <div style="width: 100%; text-align: center;" id="load-more-results-container">
                      <button class="btn" (click)="continueBrowsingInStock(currentPage);">Load More Results</button>
                    </div>
                  }
              </div>
              }
              @if (loading) {
                <div style="width: 100%; text-align: center;">
                  <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              }
            }
          </div>
        </div>
      </div>
